import {Component, Injector} from '@angular/core';
import {DeviceService} from "../device/device.service";
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";
import {DeviceAttribute} from "../model/device-attribute.model";

@Component({
    selector: 'app-device-attribute',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class DeviceAttributeComponent extends GeneralListComponent {

  constructor(
    injector: Injector,
    private deviceService: DeviceService
  ) {
    super(injector);
    this.showNewBtn = true;
    this.title = this.deviceService.getTranslation("DEVICE_ATTRIBUTES");

    this.columns = [
      {id: 'name',label: this.deviceService.getTranslation("NAME"), type: ColumnType.Simple},
      {id: 'type',label: this.deviceService.getTranslation("TYPE"), type: ColumnType.Simple},
      {id: 'modified',label: this.deviceService.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedBy',label: this.deviceService.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
      {id: 'action', label: 'edit', type: ColumnType.Action}
    ];
  }

  fetchItems() {
    this.deviceService.getAttributes().subscribe((resp:any) => {
      if (resp) {
        this.items = resp.map(r => new DeviceAttribute(r));
        this.dataSource.data = this.items;
      }
    })
  }
}
